import "./HeroSection.css";
import heroImg from "../assets/hero_herbs.png";
import badgeIcon from "../assets/icons/badge_practitioner.svg";
import btnArrow from "../assets/icons/btn_arrow.svg";

function HeroSection({ onGetCured }) {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <img src={badgeIcon} alt="" width="24" height="24" />
            <span className="hero-badge-text">
              Licensed practitioner reviewed
            </span>
          </div>
          <h1 className="hero-title">
            Custom <em className="hero-title-italic">Chinese Herbal</em>{" "}
            Medicine, tailored to your body
          </h1>
          <p className="hero-desc">
            Personalized herbal medicine, selected for your body and your
            symptoms. Rooted in over 2,000 years of traditional Chinese herbal
            practice.
          </p>
          <button className="hero-btn" onClick={onGetCured}>
            Start your intake
            <img src={btnArrow} alt="" width="20" height="20" />
          </button>
        </div>
        <div className="hero-image">
          <img src={heroImg} alt="Herbs and medicine" className="hero-img" />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
